import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Tooltip } from '../components/Tooltip';
import { TextInput } from './TextInput';
import { Icon } from '@emorg-prd/standard-react';
import './ReadOnly.css'


interface ReadOnlyFieldProps {
    label: string;
    text: string;
    copy?: boolean;
    note?: string;
    className?: string;
}

interface ReadonlyFieldState {
    copied: boolean;
}

export default class ReadOnlyField extends React.Component<ReadOnlyFieldProps, ReadonlyFieldState> {

    constructor(props) {
        super(props);
        this.state = {
            copied: false,
        };
    }

    render() {
        return (
            <div className={`em-c-field em-field-with-action ${this.props.className ?? ''}`}>
                <div className="em-field-with-action__input">
                    <TextInput
                        label={this.props.label}
                        onChange={() => { }}
                        readOnly
                        type="text"
                        value={this.props.text}
                        note={this.props.note}
                        className="em-field-with-action__textinput"
                    />
                </div>


                {this.props.copy && (
                    <div className="em-field-with-action__action">
                        <Tooltip
                            name={
                                <CopyToClipboard
                                    text={this.props.text}
                                    onCopy={() => this.setState({ copied: true })}
                                >
                                    <button
                                        type="button"
                                        className="em-c-btn em-c-btn--secondary em-field-with-action__copy-btn"
                                        onBlur={() => this.setState({ copied: false })}
                                    >
                                        <Icon
                                            name="copy"
                                            size="em-c-icon--small"
                                        />
                                    </button>
                                </CopyToClipboard>}
                            content={this.state.copied ? 'Copied!' : 'Copy to clipboard'}
                            optionalClass="em-field-with-action__tooltip"
                        >
                            <></>
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }
}